var _path, _ellipse, _path2, _rect, _rect2, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChurch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 102,
    viewBox: "0 0 60 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0383 87.94H10.7101C9.50515 87.94 8.52832 86.9631 8.52832 85.7582V52.667C8.52832 51.8789 8.95341 51.152 9.64033 50.7655L28.9311 39.9124C29.5954 39.5387 30.4065 39.5387 31.0707 39.9124L40.7372 45.3508L44.7441 47.6543L50.3509 50.7677C51.0438 51.1525 51.4735 51.8827 51.4735 52.6752V72.4809V85.7582C51.4735 86.9631 50.4967 87.94 49.2917 87.94H38.9636C37.7586 87.94 36.7817 86.9631 36.7817 85.7582V70.1832C36.7817 69.5608 36.5159 68.9681 36.0512 68.5541L31.4522 64.4573C30.625 63.7205 29.3769 63.7205 28.5497 64.4573L23.9507 68.5541C23.4859 68.9681 23.2201 69.5608 23.2201 70.1832V85.7582C23.2201 86.9631 22.2433 87.94 21.0383 87.94Z",
    fill: "#5A5A5A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0518,
    cy: 54.104,
    rx: 5.2911,
    ry: 5.27246,
    fill: "#5A5A5A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0273 29.7546V42.6762C16.0273 43.5084 16.9218 44.0342 17.6489 43.6293L29.4691 37.0471C29.7991 36.8634 30.2006 36.8634 30.5306 37.0471L42.3508 43.6293C43.078 44.0342 43.9725 43.5084 43.9725 42.6762V29.7546C43.9725 29.1522 44.4609 28.6637 45.0634 28.6637H45.2725C45.875 28.6637 46.3634 28.1753 46.3634 27.5728V25.5572C46.3634 24.9547 45.875 24.4662 45.2725 24.4662H42.5351C42.1974 24.4662 41.8788 24.3099 41.6722 24.0428L31.3187 10.6584C31.1708 10.4673 31.0906 10.2326 31.0906 9.99094V7.09091C31.0906 6.48842 31.5791 6 32.1815 6H33.8179C34.4204 6 34.9088 5.51158 34.9088 4.90909C34.9088 4.3066 34.4204 3.81818 33.8179 3.81818H32.1816C31.5791 3.81818 31.0906 3.32977 31.0906 2.72727V1.09091C31.0906 0.488416 30.6022 0 29.9997 0C29.3972 0 28.9088 0.488416 28.9088 1.09091V2.72727C28.9088 3.32977 28.4204 3.81818 27.8179 3.81818H26.1816C25.5791 3.81818 25.0906 4.3066 25.0906 4.90909C25.0906 5.51158 25.5791 6 26.1816 6H27.8179C28.4204 6 28.9088 6.48842 28.9088 7.09091V9.98763C28.9088 10.2313 28.8273 10.4679 28.6771 10.6598L18.2042 24.0475C17.9974 24.3118 17.6805 24.4662 17.3449 24.4662H14.6524C14.0499 24.4662 13.5615 24.9547 13.5615 25.5572V27.5728C13.5615 28.1753 14.0499 28.6637 14.6524 28.6637H14.9364C15.5389 28.6637 16.0273 29.1522 16.0273 29.7546Z",
    fill: "#5A5A5A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.03418,
    y: 89.373,
    width: 49.9315,
    height: 5.32365,
    rx: 2.18182,
    fill: "#5A5A5A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 96.1304,
    width: 60,
    height: 5.32365,
    rx: 2.18182,
    fill: "#5A5A5A"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.0004,
    cy: 29.2779,
    rx: 3.69863,
    ry: 3.6856,
    fill: "#5A5A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch);
export default __webpack_public_path__ + "static/media/church.41af06d85398e466ad560310ce813cc0.svg";
export { ForwardRef as ReactComponent };